export const routes = {
  HOME: 'home',
  VOTE: 'vote',
  WAIT: 'wait',
  RESULT: 'result',
  RESET: 'reset',
  SUBMIT_QUESTION: 'submit_question',
  ADMIN_CENTER: 'admin_center',
  RESULT_HISTORY: 'result_history',
};

export const localStorageKeys = {
  AUTH_TOKEN: 'AUTH_TOKEN',
};

export const mutations = {
  SET_USER_INFO: 'SET_USER_INFO',
  SET_USER_INFO_FAILURE: 'SET_USER_INFO_FAILURE',
};

export const actions = {
  GET_USER_INFO: 'GET_USER_INFO',
};
